import angular from 'angular'
import coreModule from '../core'
import shellComponent from './shell.component'

export default angular.module('app.layout', [coreModule]).component('elShell', shellComponent)
